// 物流公司高级弹窗配置
export default {
    logisticsCompanyConfig: {
        name: '物流公司',
        value: 'logisticsCompanyName',
        type: 'advance',
        unfold: true,
        advanceConfig: [
            { prop: 'logisticsCompanyName', value: '物流公司名称' },
            { prop: 'logisticsCompanyCode', value: '物流公司编码' }
        ],
        tableConfig: [
            { prop: 'logisticsCompanyName', value: '物流公司名称' },
            { prop: 'logisticsCompanyCode', value: '物流公司编码' }
        ],
        prefix: '/api-antms/common',
        advanceUrl: '/lsp/transfer/logisticsCompanyQuery',
        method: 'post',
        paramType: true,
        cbParams: ['logisticsCompanyCode#logisticsCompanyCode', 'logisticsCompanyName#logisticsCompanyName', 'expressType#expressType']
    },
    ImportConfig: {
        action: `${process.env.VUE_APP_API_URL || ''}/api-antms/transport/lsp/transfer/expressImportCheck`,
        multiple: true,
        accept: '.xlsx', // 筛选文件
        showFileList: true,
        fileType: '只能上传Excel文件，且不能超过500KB，导入数据一次不能超过50条',
        manualUpload: false // 手动上传
    },
    ImportContent: [
        {
            'fileName': '批量转快递导入模板.xlsx',
            'fileSize': '44KB',
            'downLoadInfo': {
                'url': ''
            }
        }
    ],
    verifyConfig: {
        switch: true, // 是否开启校验
        fileSize: 500 // 校验文件大小（单位为KB）不传该属性，则不校验
    }
}
